import Link from "next/link";
import { ArrowRight, type LucideIcon } from "lucide-react";
import type { TherapyGuideAccent } from "~/config/vodic-kroz-psihoterapiju";
import { cn } from "~/lib/utils";

interface AccentFeatureCardProps {
  href: string;
  icon: LucideIcon;
  title: string;
  description: string;
  accent: TherapyGuideAccent;
  /** Bottom link label, defaults to the therapy directory's copy */
  ctaLabel?: string;
}

export function AccentFeatureCard({
  href,
  icon: Icon,
  title,
  description,
  accent,
  ctaLabel = "Saznaj više",
}: AccentFeatureCardProps) {
  return (
    <Link
      href={href}
      className={cn(
        "group flex min-h-52 flex-col justify-between gap-8 rounded-2xl p-5 transition-colors md:min-h-60 md:p-6",
        accent.category,
      )}
    >
      <Icon className="size-7" strokeWidth={1.5} aria-hidden="true" />
      <div>
        <h3 className="marketing-heading text-2xl font-medium tracking-tight md:text-3xl">
          {title}
        </h3>
        <p
          className="mt-2 max-w-md text-sm leading-relaxed opacity-80 md:text-base"
          style={{
            display: "-webkit-box",
            overflow: "hidden",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 2,
          }}
        >
          {description}
        </p>
        <span className="mt-5 flex items-center gap-1.5 text-sm font-medium">
          {ctaLabel}
          <ArrowRight
            className="size-4 transition-transform group-hover:translate-x-1"
            aria-hidden="true"
          />
        </span>
      </div>
    </Link>
  );
}
